import axios from '../axios'
//设备台数统计导出
export const exportEquipmentStatistics = (data) => {
  return axios({
    url: '/api/sys/export/eq/exportEquipmentStatistics',
    method: 'post',
    data
  })
}
//年度收支统计导出
export const exportYearReceivingPayments = (data) => {
  return axios({
    url: '/api/sys/export/eq/exportYearReceivingPayments',
    method: 'post',
    data
  })
}
//营业额统计导出
export const exportTurnoverStatistics = (data) => {
  return axios({
    url: '/api/sys/export/eq/exportTurnoverStatistics',
    method: 'post',
    data
  })
}


// 下载物料表模板
export const uploadBaseMaterialListTemplate = (data) => {
  return axios({
    url: '/api/sys/uploadBaseMaterialListTemplate',
    method: 'post',
    data,
    responseType: 'blob'
  })
}
export const uploadBaseMaterialList = (data) => {
  return axios({
    url: '/api/sys/uploadBaseMaterialList',
    method: 'post',
    data,
  })
}
//单位常用联系人导入模板
export const uploadBasePartnerContactListTemplate = (data) => {
  return axios({
    url: '/api/sys/uploadBasePartnerContactListTemplate',
    method: 'post',
    data,
    responseType: 'blob'
  })
}
//单位常用联系人导入
export const uploadBasePartnerContactList = (data) => {
  return axios({
    url: '/api/sys/uploadBasePartnerContactList',
    method: 'post',
    data
  })
}
//单位车辆导入模板
export const uploadBasePartnerWxCarContactListTemplate = (data) => {
  return axios({
    url: '/api/sys/uploadBasePartnerWxCarContactListTemplate',
    method: 'post',
    data,
    responseType: 'blob'
  })
}
//单位车辆导入
export const uploadBasePartnerWxCarContactList = (data) => {
  return axios({
    url: '/api/sys/uploadBasePartnerWxCarContactList',
    method: 'post',
    data
  })
}
//单位常用地址导入模板
export const uploadBasePartnerAddressContactListTemplate = (data) => {
  return axios({
    url: '/api/sys/uploadBasePartnerAddressContactListTemplate',
    method: 'post',
    data,
    responseType: 'blob'
  })
}
//单位常用地址导入
export const uploadBasePartnerAddressContactList = (data) => {
  return axios({
    url: '/api/sys/uploadBasePartnerAddressContactList',
    method: 'post',
    data
  })
}
//单位司机导入模板
export const uploadBasePartnerWxDriverContactListTemplate = (data) => {
  return axios({
    url: '/api/sys/base/uploadBasePartnerWxDriverContactListTemplate',
    method: 'post',
    data,
    responseType: 'blob'
  })
}
//单位司机导入
export const uploadBasePartnerWxDriverContactList = (data) => {
  return axios({
    url: '/api/sys/base/uploadBasePartnerWxDriverContactList',
    method: 'post',
    data
  })
}
//分析中心——安排抽检导出
export const exportMeterBookingCarCompareList = (data) => {
  return axios({
    url: '/api/sys/meter/exportMeterBookingCarCompareList',
    method: 'post',
    data
  })
}
//分析中心——采样确认导出
export const exportMeterWayCarSampleList = (data) => {
  return axios({
    url: '/api/sys/meter/meterWayCar/exportMeterWayCarSampleList',
    method: 'post',
    data
  })
}
//导出报警日志
export const exportIotDeviceAlarmLogList = (data) => {
  return axios({
    url: '/api/sys/iot/device/alarm/log/exportIotDeviceAlarmLogList',
    method: 'post',
    data
  })
}
//导出采购合同审批PDF
export const exportPurContractReviewPDF = (data) => {
  return axios({
    url: '/api/sys/pur/order/exportPurContractReviewPDF',
    method: 'post',
    data
  })
}
//销售报价单PDF
export const exportSalQuotationPDF = (data) => {
  return axios({
    url: '/api/sys/sal/order/exportSalQuotationPDF',
    method: 'post',
    data
  })
}
//销售合同审批PDF
export const exportSalContractReviewPDF = (data) => {
  return axios({
    url: '/api/sys/sal/order/exportSalContractReviewPDF',
    method: 'post',
    data
  })
}
//采购废铁报价PDF
export const exportPurEvaluationPDF = (data) => {
  return axios({
    url: '/api/sys/pur/evaluation/exportPurEvaluationPDF',
    method: 'post',
    data
  })
}
//导出员工进出
export const exportIotDeviceTrafficList = (data) => {
  return axios({
    url: '/api/sys/iot/device/traffic/exportIotDeviceTrafficList',
    method: 'post',
    data
  })
}
//导出销售合同表
export const exportSalContractFormReport = (data) => {
  return axios({
    url: '/api/sys/sal/order/exportSalContractFormReport',
    method: 'post',
    data
  })
}
//导出销售合同表
export const exportShippingStatisticsReport = (data) => {
  return axios({
    url: '/api/sys/sal/order/exportShippingStatisticsReport',
    method: 'post',
    data
  })
}
//销售发票导出pdf
export const exportInvoicePDF = (data) => {
  return axios({
    url: '/api/sys/fin/receivables/exportInvoicePDF',
    method: 'post',
    data
  })
}
//销售合同的PDF
export const exportSalContractPDF = (data) => {
  return axios({
    url: '/api/sys/sal/order/exportSalContractPDF',
    method: 'post',
    data
  })
}
//车评铁单，废铁质检单
export const exportPurAccessQualityInspectionPDF = (data) => {
  return axios({
    url: '/api/sys/pur/access/exportPurAccessQualityInspectionPDF',
    method: 'post',
    data
  })
}
//过磅列表，过磅单pdf
export const exportMeterWeightPDF = (data) => {
  return axios({
    url: '/api/sys/meter/weight/exportMeterWeightPDF',
    method: 'post',
    data
  })
}
//过磅列表，过磅单excel
export const exportMeterWeightExcel = (data) => {
  return axios({
    url: '/api/sys/meter/weight/exportMeterWeightExcel',
    method: 'post',
    data
  })
}
//补打过磅单
export const exportPatchworkMeterWeightExcel = (data) => {
  return axios({
    url: '/api/sys/pur/arrival/exportPatchworkMeterWeightExcel',
    method: 'post',
    data
  })
}
//补打废铁质检单
export const exportPatchworkPurAccess = (data) => {
  return axios({
    url: '/api/sys/pur/arrival/exportPatchworkPurAccess',
    method: 'post',
    data
  })
}
//导出采购结算单明细对账单
export const exportSettleAccountStatement = (data) => {
  return axios({
    url: '/api/sys/pur/arrival/exportSettleAccountStatement',
    method: 'post',
    data
  })
}
//导出到货单质检单PDF
export const exportPatchworkPurAccessPDF = (data) => {
  return axios({
    url: '/api/sys/pur/arrival/exportPatchworkPurAccessPDF',
    method: 'post',
    data
  })
}
//获取过磅单数据
export const getPatchworkMeterWeight = (data) => {
  return axios({
    url: '/api/sys/pur/arrival/getPatchworkMeterWeight',
    method: 'post',
    data
  })
}
// 销售合同对账单
export const exportSalAccountStatement = data => {
  return axios({
    url: '/api/sys/sal/order/exportSalAccountStatement',
    method: 'post',
    data
  })
};
// 柜号导入
export const uploadPurOrderContainer = data => {
  return axios({
    url: '/api/sys/pur/order/container/uploadPurOrderContainer',
    method: 'post',
    data
  })
};
// 分组派发项目导出
export const exportBaseGroupTaskList = data => {
  return axios({
    url: '/api/sys/base/group/task/exportBaseGroupTaskList',
    method: 'post',
    data
  })
};
// 直采、长协多退少补（B账）|采购对账单导出
export const exportBAccount = data => {
  return axios({
    url: '/api/sys/pur/arrival/exportBAccount',
    method: 'post',
    data
  })
};
// 导出采购运输物流损耗赔偿表
export const exportTransportLoss = data => {
  return axios({
    url: '/api/sys/pur/arrival/exportTransportLoss',
    method: 'post',
    data
  })
};
// 导出订柜台账（K,B账）
export const exportKBAccount = data => {
  return axios({
    url: '/api/sys/pur/order/exportKBAccount',
    method: 'post',
    data
  })
};
// 导出库存日报(广东场地区外库存表（K,B账）)
export const exportInventoryDailyReport = data => {
  return axios({
    url: '/api/sys/stk/exportInventoryDailyReport',
    method: 'post',
    data
  })
};
// 场地移库列表导出
export const getStkInternalWeighingConversionExport = data => {
  return axios({
    url: '/api/sys/stk/getStkInternalWeighingConversionExport',
    method: 'post',
    data
  })
};
// 本部移库列表导出
export const getHeadquartersStkInternalWeighingConversionExport = data => {
  return axios({
    url: '/api/sys/stk/getHeadquartersStkInternalWeighingConversionExport',
    method: 'post',
    data
  })
};
// 码头转运误差报表导出
export const dockTransshipment = data => {
  return axios({
    url: '/api/sys/pur/arrival/dockTransshipment',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/excel.js